/* eslint-disable no-unused-vars */


import Router from 'vue-router';

const Stage = () => import('./components/StageComponent.vue');
const StageBlock = () => import('./components/StageBlockComponent.vue')
const StageBlockDispatcher = () => import('./components/StageBlockDispatcher.vue')
const QuestionDispatcher = () => import('./components/QuestionDispatcher.vue')
const StageStart = () => import('./components/StageStartComponent.vue')
const StageFinish = () => import('./components/StageFinishComponent.vue')
const Profile = () => import('./components/ProfileComponent.vue')
const AboutMeForm = () => import('./components/profile/AboutMeFormComponent.vue')
const MyHeritageForm = () => import('./components/profile/MyHeritageFormComponent.vue')
const MySchoolForm = () => import('./components/profile/MySchoolFormComponent.vue')
const EligibilityIntro = () => import('./components/EligibilityIntroComponent.vue')
const GuardianForm = () => import('./components/profile/GuardianFormComponent.vue')
const Question = () => import('./components/QuestionComponent.vue')
const MyFamilyForm = () => import('./components/profile/MyFamilyFormComponent.vue')
const HomeDashboard = () => import('./components/DashboardComponent.vue');
const LandingPage = () => import('./components/MyLandingPageComponent.vue');

const Interview = () => import('./components/interview/InterviewComponent.vue')
const FormHome = () => import('./components/FormHomeComponent.vue')
const FormFinish = () => import('./components/FormFinishComponent.vue')

const SalesforceSSO = () => import('./components/SalesforceSSOComponent.vue')

const ApplicationPass = () => import('./components/ApplicationPassComponent.vue')

const Welcome = () => import('./components/WelcomeComponent.vue')
const Guest = () => import('./components/GuestComponent.vue')
//const Guest2 = () => import('./components/Guest2Component.vue')

const Reference = () => import('./components/ReferenceComponent.vue')
const ReferenceHome = () => import('./components/reference/HomeComponent.vue')
const ReferenceSchool = () => import('./components/reference/SchoolComponent.vue')
const ReferenceCommunity = () => import('./components/reference/CommunityComponent.vue')
const ReferenceGuardian = () => import('./components/reference/GuardianComponent.vue')
const ReferenceGuardian1 = () => import('./components/reference/MyDetailFormComponent.vue')
const ReferenceGuardian2 = () => import('./components/reference/MyEndorsementComponent.vue')
const ReferenceGuardian3 = () => import('./components/reference/MyDeclarationComponent.vue')

const ProfilePage = () => import('./components/ProfilePage.vue')
const ProfileHome = () => import('./components/profile/ProfileHomeComponent.vue')
const HistoryPage = () => import('./components/HistoryPage.vue')
const ConsentPage = () => import('./components/ConsentPage.vue')

// import { stages } from './db/testdb.js';
import store from './store.js';

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/', 
            redirect: { name: 'home.dashboard' }
        },
        {
            path: '/consent',
            name: 'consent',
            component: ConsentPage
        },
        
        
        {
            path: '/dashboard',
            name: 'home.dashboard',
            component: HomeDashboard
        },
        {
            path: '/profile',
            name: 'profile',
            component: ProfilePage,
            children: [
                   {
                       path: 'home',
                       name: 'profile.home',
                       component: ProfileHome
                   },
                   {
                       path: 'me',
                       name: 'profile.me',
                       component: AboutMeForm
                   },
                   {
                       path: 'heritage',
                       name: 'profile.heritage',
                       component: MyHeritageForm
                   },
                   {
                       path: 'school',
                       name: 'profile.school',
                       component: MySchoolForm
                   },
                   {
                       path: 'family',
                       name: 'profile.family',
                       component: MyFamilyForm
                   }
                ]
        },
        {
            path: '/history',
            name: 'history',
            component: HistoryPage
        },
        {
            path: '/reference/:reference_id',
            name: 'reference',
            component: Reference,
            children: [
                {
                    path: 'home',
                    name: 'reference.home',
                    props: true,
                    component: ReferenceHome
                },
                {
                    path: 'school',
                    name: 'reference.school',
                    component: ReferenceSchool
                },
                {
                    path: 'community',
                    name: 'reference.community',
                    component: ReferenceCommunity
                },
                {
                    path: 'guardian',
                    name: 'reference.guardian',
                    component: ReferenceGuardian,
                    props:{
                        totalPages: 3
                    },
                    children: [
                        {
                            path: "1",
                            name: "guardian.1",
                            component: ReferenceGuardian1,
                            meta: {
                                pageNumber: 1
                            }
                        },
                        {
                            path: "2",
                            name: "guardian.2",
                            component: ReferenceGuardian2,
                            meta: {
                                pageNumber: 2
                            }
                        },
                        {
                            path: "3",
                            name: "guardian.3",
                            component: ReferenceGuardian3,
                            meta: {
                                pageNumber: 3
                            }
                        }
                    ]
                },
            ]
        },
        {
            path: '/landingpage',
            name: 'landingpage',
            component: LandingPage,

        },
        {
            path: '/welcome',
            name: 'welcome',
            component: Guest,
            children: [
                
                {
                    path: 'eligibility',
                    component: Welcome,
                    props: {
                        sectionCount: 5
                    },
                    children: [
                        
                        {
                            path: "0",
                            name: 'eligibility.0',
                            component: EligibilityIntro,
                            meta: {
                                sort: 0
                            }
                        },
                        {
                            path: "1",
                            name: 'eligibility.1',
                            component: AboutMeForm,
                            meta: {
                                sort: 1
                            }
                        },
                        {
                            path: "2",
                            name: 'eligibility.2',
                            component: MyHeritageForm,
                            meta: {
                                sort: 2
                            }
                        },
                        {
                            path: "3",
                            name: 'eligibility.3',
                            component: MySchoolForm,
                            meta: {
                                sort: 3
                            }
                        },
                        {
                            path: "4",
                            name: 'eligibility.4',
                            component: MyFamilyForm,
                            meta: {
                                sort: 4
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: '/salesforce/sso/callback',
            name: 'salesforce.sso.callback',
            component: SalesforceSSO
        },
        {
            path: '/applications/:application_id',
            name: 'application',
            component: ApplicationPass,
            props: true,
            children: [
                {
                    path: 'dashboard',
                    name: 'application.dashboard',
                    props: true,
                    component: FormHome
                },
                {
                    path: 'finish',
                    name: 'application.finish',
                    props: true,
                    component: FormFinish
                },
                {
                    path: 'stage',
                    name: 'stage',
                    component: Stage,
                    props: true,
                    children: [
                        // {
                        //     path: 'start/:stage_key',
                        //     name: 'stage.start',
                        //     component: StageStart,
                        //     props: true
                        // },
                        // {
                        //     path: 'finish/:stage_key',
                        //     name: 'stage.finish',
                        //     component: StageFinish,
                        //     props: true
                        // },
                        {
                            path: ':stage_key',
                            name: 'stage.block',
                            component: StageBlockDispatcher,
                            props: true,
                            // children: [
                            //     {
                            //         path: ':sort',
                            //         name: 'stage.question',
                            //         component: QuestionDispatcher,
                            //         props: true
                            //     },
                            // ]
                        },
                    ]
                }
            ]
        }
    ]
})

const ROUTE_WHITELIST = [
    '/reference/',
    '/consent',
]

router.beforeEach((to, from, next) => {
    if(ROUTE_WHITELIST.some(url => to.path.startsWith(url))) {
        next();
        return;
    }
    if(!document.cookie.includes('consent=')) {
        window.location.href = '/consent';
        return;
    }
    if (to.name === 'salesforce.sso.callback') {
        console.log('sso route')
        next(); return;
    }
    if(!document.cookie.includes('exp=')) {
        const redirectionUrl = process.env.VUE_APP_SALESFORCE_REDIRECT_URL.replace('{{HOST}}', window.location.host);
        window.location.href = redirectionUrl;
        return;
    }
    next(); return;
});

export default router;